import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.remote)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.targetUrl,
        class: _normalizeClass(_ctx.topClass)
      }, [
        _createElementVNode("img", {
          src: _ctx.POLYGONJS_LOGO_URL,
          class: _normalizeClass(_ctx.imageClass)
        }, null, 10 /* CLASS, PROPS */, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.labelClass)
        }, "Polygonjs", 2 /* CLASS */)
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: _ctx.targetUrl,
        class: _normalizeClass(_ctx.topClass)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_XMarkIcon, {
            src: _ctx.POLYGONJS_LOGO_URL,
            class: _normalizeClass(_ctx.imageClass)
          }, null, 8 /* PROPS */, ["src", "class"]),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.labelClass)
          }, "Close", 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to", "class"]))
}